<template>
  <div class="action">
    <CollectInformationAction v-if="action.type=='CollectInformationAction'"
      v-bind:action="action">
    </CollectInformationAction>

    <ManualTaskAction v-if="action.type=='ManualTaskAction'"
      v-bind:action="action">
    </ManualTaskAction>

  </div>
</template>

<script>
import CollectInformationAction from '@/components/CollectInformationAction'
import ManualTaskAction from '@/components/ManualTaskAction'

export default {
  name: 'Action',
  props: ['action'],
  components: {
    CollectInformationAction,
    ManualTaskAction
  },
  computed: {

  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
